import script from "./MultasListComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MultasListComponent.vue?vue&type=script&setup=true&lang=js"

import "./MultasListComponent.vue?vue&type=style&index=0&id=1e21ee8b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e21ee8b"]])

export default __exports__